import {
  GET_ALL_ORG_NEWRELIC_RESOURCE_TYPES,
  GET_ALL_ORG_NEWRELIC_RESOURCE_TYPES_FAIL,
  GET_ALL_ORG_NEWRELIC_RESOURCE_TYPES_SUCCESS,
  GET_NEWRELIC_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID,
  GET_NEWRELIC_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID_FAIL,
  GET_NEWRELIC_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID_SUCCESS,
  GET_NEWRELIC_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID,
  GET_NEWRELIC_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID_FAIL,
  GET_NEWRELIC_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID_SUCCESS,
  DEPLOY_NEW_RELIC_DYNAMIC_ALERTS_BY_RESOURCE_ID,
  DEPLOY_NEW_RELIC_DYNAMIC_ALERTS_BY_RESOURCE_ID_FAIL,
  DEPLOY_NEW_RELIC_DYNAMIC_ALERTS_BY_RESOURCE_ID_SUCCESS,
  GET_NEWRELIC_ALL_RESOURCE_ALERTS,
  GET_NEWRELIC_ALL_RESOURCE_ALERTS_FAIL,
  GET_NEWRELIC_ALL_RESOURCE_ALERTS_PAGE,
  GET_NEWRELIC_ALL_RESOURCE_ALERTS_PAGE_FAIL,
  GET_NEWRELIC_ALL_RESOURCE_ALERTS_PAGE_SUCCESS,
  GET_NEWRELIC_ALL_RESOURCE_ALERTS_SUCCESS,
  GET_NEWRELIC_RESOURCE_BY_ID,
  GET_NEWRELIC_RESOURCE_BY_ID_FAIL,
  GET_NEWRELIC_RESOURCE_BY_ID_SUCCESS,
  POST_NEW_RELIC_RESOURCE_OPSGENIE_TEAM_MAPPING,
  POST_NEW_RELIC_RESOURCE_OPSGENIE_TEAM_MAPPING_FAIL,
  POST_NEW_RELIC_RESOURCE_OPSGENIE_TEAM_MAPPING_SUCCESS,
  POST_NEW_RELIC_RESOURCE_PAGERDUTY_SERVICE_MAPPING,
  POST_NEW_RELIC_RESOURCE_PAGERDUTY_SERVICE_MAPPING_FAIL,
  POST_NEW_RELIC_RESOURCE_PAGERDUTY_SERVICE_MAPPING_SUCCESS,
  POST_NEW_RELIC_SERVICE_MAPPING,
  POST_NEW_RELIC_SERVICE_MAPPING_FAIL,
  POST_NEW_RELIC_SERVICE_MAPPING_SUCCESS,
  POST_UPDATE_NEWRELIC_RESOURCE_ENVIRONMENT,
  POST_UPDATE_NEWRELIC_RESOURCE_ENVIRONMENT_FAIL,
  POST_UPDATE_NEWRELIC_RESOURCE_ENVIRONMENT_SUCCESS,
  GET_DEFAULT_THRESHOLDS_NEWRELIC_RESOURCE_BY_ID,
  GET_DEFAULT_THRESHOLDS_NEWRELIC_RESOURCE_BY_ID_SUCCESS,
  GET_DEFAULT_THRESHOLDS_NEWRELIC_RESOURCE_BY_ID_FAIL,
  POST_NEW_RELIC_DISABLE_ALERTS_SUCCESS,
  POST_NEW_RELIC_DISABLE_ALERTS,
  POST_NEW_RELIC_DISABLE_ALERTS_FAIL,
  POST_NEW_RELIC_ENABLE_ALERTS,
  POST_NEW_RELIC_ENABLE_ALERTS_SUCCESS,
  POST_NEW_RELIC_ENABLE_ALERTS_FAIL,
  GET_NEWRELIC_ALERTS_SUCCESS,
  GET_NEWRELIC_ALERTS_FAIL,
  GET_NEWRELIC_ALERTS,
  GET_NEWRELIC_ALL_RESOURCE_COUNT,
  GET_NEWRELIC_ALL_RESOURCE_COUNT_FAIL,
  GET_NEWRELIC_ALL_RESOURCE_COUNT_SUCCESS,
  POST_NEWRELIC_MARK_TRANSACTION_AS_KEY_TRANSACTION,
  POST_NEWRELIC_MARK_TRANSACTION_AS_KEY_TRANSACTION_SUCCESS,
  POST_NEWRELIC_MARK_TRANSACTION_AS_KEY_TRANSACTION_FAIL,
  POST_NEWRELIC_DELETE_KEY_TRANSACTION,
  POST_NEWRELIC_DELETE_KEY_TRANSACTION_SUCCESS,
  POST_NEWRELIC_DELETE_KEY_TRANSACTION_FAIL,
  GET_NEWRELIC_TRANSACTIONS_BY_APM,
  GET_NEWRELIC_TRANSACTIONS_BY_APM_SUCCESS,
  GET_NEWRELIC_TRANSACTIONS_BY_APM_FAIL,
  GET_NEWRELIC_EXTERNAL_SERVICES,
  GET_NEWRELIC_EXTERNAL_SERVICES_SUCCESS,
  GET_NEWRELIC_EXTERNAL_SERVICES_FAIL,
  GET_NEWRELIC_EXTERNAL_SERVICES_RESOURCE_COUNT,
  GET_NEWRELIC_EXTERNAL_SERVICES_RESOURCE_COUNT_SUCCESS,
  GET_NEWRELIC_EXTERNAL_SERVICES_RESOURCE_COUNT_FAIL,
  GET_USER_RESCAN_STATUS_NEWRELIC, GET_USER_RESCAN_STATUS_NEWRELIC_SUCCESS, GET_USER_RESCAN_STATUS_NEWRELIC_FAIL,
} from "./actionTypes";

const INIT_STATE = {
  all_resource_alerts: {},
  newRelic_all_resource_count: {},
  newrelic_external_services_resource_count: {},
  newrelic_external_services: {},
  newrelic_resource: {},
  orgNewRelicResourceTypes: [],
  default_threshold_newRelic_resource: [],
  new_relic_alerts: [],
  resource_missing_dynamic_alerts: {},
  resource_dynamic_alerts_deployed: {},
  deployed_new_alert: {},
  new_relic_transaction: [],
  transactions_by_apm: [],
  new_relic_rescan_status: true,
};

const NewRelic = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_NEWRELIC_ALL_RESOURCE_ALERTS:
      return {
        ...state,
        error: action.payload,
      }

    case GET_NEWRELIC_ALL_RESOURCE_ALERTS_SUCCESS:
      return {
        ...state,
        all_resource_alerts: action.payload,
      }

    case GET_NEWRELIC_ALL_RESOURCE_ALERTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_NEWRELIC_ALL_RESOURCE_ALERTS_PAGE:
      return {
        ...state,
        error: action.payload,
      }

    case GET_NEWRELIC_ALL_RESOURCE_ALERTS_PAGE_SUCCESS:
      return {
        ...state,
        all_resource_alerts: action.payload,
      }

    case GET_NEWRELIC_ALL_RESOURCE_ALERTS_PAGE_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_NEWRELIC_EXTERNAL_SERVICES:
        return {
            ...state,
            error: action.payload,
        }

    case GET_NEWRELIC_EXTERNAL_SERVICES_SUCCESS:
        return {
            ...state,
            newrelic_external_services: action.payload,
        }

    case GET_NEWRELIC_EXTERNAL_SERVICES_FAIL:
        return {
            ...state,
            error: action.payload,
        }

    case GET_NEWRELIC_ALL_RESOURCE_COUNT:
      return {
        ...state,
        error: action.payload,
      }

    case GET_NEWRELIC_ALL_RESOURCE_COUNT_SUCCESS:
      return {
        ...state,
        newRelic_all_resource_count: action.payload,
      }

    case GET_NEWRELIC_ALL_RESOURCE_COUNT_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_NEWRELIC_EXTERNAL_SERVICES_RESOURCE_COUNT:
        return {
            ...state,
            error: action.payload,
        }

    case GET_NEWRELIC_EXTERNAL_SERVICES_RESOURCE_COUNT_SUCCESS:
        return {
            ...state,
          newrelic_external_services_resource_count: action.payload,
        }

    case GET_NEWRELIC_EXTERNAL_SERVICES_RESOURCE_COUNT_FAIL:
        return {
            ...state,
            error: action.payload,
        }

    case GET_ALL_ORG_NEWRELIC_RESOURCE_TYPES:
      return {
        ...state,
        error: action.payload,
      }

    case GET_ALL_ORG_NEWRELIC_RESOURCE_TYPES_SUCCESS:
      return {
        ...state,
        orgNewRelicResourceTypes: action.payload,
      }

    case GET_ALL_ORG_NEWRELIC_RESOURCE_TYPES_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_NEWRELIC_RESOURCE_BY_ID:
      return {
        ...state,
        error: action.payload,
      }

    case GET_NEWRELIC_RESOURCE_BY_ID_SUCCESS:
      return {
        ...state,
        newrelic_resource: action.payload
      }

    case GET_NEWRELIC_RESOURCE_BY_ID_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_DEFAULT_THRESHOLDS_NEWRELIC_RESOURCE_BY_ID:
      return {
        ...state,
        error: action.payload,
      }

    case GET_DEFAULT_THRESHOLDS_NEWRELIC_RESOURCE_BY_ID_SUCCESS:
      return {
        ...state,
        default_threshold_newRelic_resource: action.payload
      }

    case GET_DEFAULT_THRESHOLDS_NEWRELIC_RESOURCE_BY_ID_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case POST_NEW_RELIC_RESOURCE_OPSGENIE_TEAM_MAPPING:
      return {
        ...state,
        error: action.payload,
      }

    case POST_NEW_RELIC_RESOURCE_OPSGENIE_TEAM_MAPPING_SUCCESS:
      action.payload.map((item) => {
        state.all_resource_alerts[item.id].opsgenie_team_id = item.opsgenie_team_id;
        state.all_resource_alerts[item.id].environment = item.environment;
      });
      return {
        ...state,
        all_resource_alerts: state.all_resource_alerts,
      }

    case POST_NEW_RELIC_RESOURCE_OPSGENIE_TEAM_MAPPING_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case POST_NEW_RELIC_RESOURCE_PAGERDUTY_SERVICE_MAPPING:
      return {
        ...state,
        error: action.payload,
      }

    case POST_NEW_RELIC_RESOURCE_PAGERDUTY_SERVICE_MAPPING_SUCCESS:
      action.payload.map((item) => {
        state.all_resource_alerts[item.id].pagerduty_service_id = item.pagerduty_service_id;
        state.all_resource_alerts[item.id].environment = item.environment;
      });
      return {
        ...state,
        all_resource_alerts: state.all_resource_alerts,
      }

    case POST_NEW_RELIC_RESOURCE_PAGERDUTY_SERVICE_MAPPING_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case POST_NEW_RELIC_SERVICE_MAPPING:
      return {
        ...state,
        error: action.payload,
      }

    case POST_NEW_RELIC_SERVICE_MAPPING_SUCCESS:
      action.payload.map((item) => {
        state.all_resource_alerts[item.id].application_service_id = item.application_service_id;
        state.all_resource_alerts[item.id].environment = item.environment;
        state.all_resource_alerts[item.id].deployment_stage = item.deployment_stage;
      });
      return {
        ...state,
        all_resource_alerts: state.all_resource_alerts,
      }

    case POST_NEW_RELIC_SERVICE_MAPPING_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case POST_UPDATE_NEWRELIC_RESOURCE_ENVIRONMENT:
      return {
        ...state,
        error: action.payload,
      }

    case POST_UPDATE_NEWRELIC_RESOURCE_ENVIRONMENT_SUCCESS:
      action.payload.map((item) => {
        state.all_resource_alerts[item.id].environment = item.environment;
      });
      return {
        ...state,
        all_resource_alerts: state.all_resource_alerts,
      }

    case POST_UPDATE_NEWRELIC_RESOURCE_ENVIRONMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case POST_NEW_RELIC_DISABLE_ALERTS:
      return {
        ...state,
        error: action.payload,
      }

    case POST_NEW_RELIC_DISABLE_ALERTS_SUCCESS:
      return {
        ...state,
        alerts: action.payload,
      }

    case POST_NEW_RELIC_DISABLE_ALERTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case POST_NEW_RELIC_ENABLE_ALERTS:
      return {
        ...state,
        error: action.payload,
      }

    case POST_NEW_RELIC_ENABLE_ALERTS_SUCCESS:
      return {
        ...state,
        new_relic_alerts: action.payload,
      }

    case POST_NEW_RELIC_ENABLE_ALERTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_NEWRELIC_ALERTS_SUCCESS:
      return {
        ...state,
        new_relic_alerts: action.payload,
      }

    case GET_NEWRELIC_ALERTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_NEWRELIC_ALERTS:
      return {
        ...state,
        error: action.payload,
      }

    case POST_NEWRELIC_MARK_TRANSACTION_AS_KEY_TRANSACTION:
      return {
        ...state,
        error: action.payload,
      };


    case POST_NEWRELIC_MARK_TRANSACTION_AS_KEY_TRANSACTION_SUCCESS:
      return {
        ...state,
        new_relic_transaction: action.payload,
      }

    case POST_NEWRELIC_MARK_TRANSACTION_AS_KEY_TRANSACTION_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_NEWRELIC_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID_SUCCESS:
      return {
        ...state,
        resource_dynamic_alerts_deployed: action.payload,
      }

    case GET_NEWRELIC_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case POST_NEWRELIC_DELETE_KEY_TRANSACTION:
      return {
        ...state,
        error: action.payload,
      };

    case POST_NEWRELIC_DELETE_KEY_TRANSACTION_SUCCESS:
      return {
        ...state,
        new_relic_transaction: action.payload,
      }

    case POST_NEWRELIC_DELETE_KEY_TRANSACTION_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_NEWRELIC_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID:
      return {
        ...state,
        error: action.payload,
      }

    case GET_NEWRELIC_TRANSACTIONS_BY_APM:
      return {
        ...state,
        error: action.payload,
      };

    case GET_NEWRELIC_TRANSACTIONS_BY_APM_SUCCESS:
      return {
        ...state,
        transactions_by_apm: action.payload,
      }

    case GET_NEWRELIC_TRANSACTIONS_BY_APM_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_NEWRELIC_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID_SUCCESS:
      return {
        ...state,
        resource_missing_dynamic_alerts: action.payload,
      }

    case GET_NEWRELIC_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case DEPLOY_NEW_RELIC_DYNAMIC_ALERTS_BY_RESOURCE_ID:
      return {
        ...state,
        error: action.payload,
      }

    case DEPLOY_NEW_RELIC_DYNAMIC_ALERTS_BY_RESOURCE_ID_SUCCESS:
      return {
        ...state,
        deployed_new_alert: action.payload,
      }

    case DEPLOY_NEW_RELIC_DYNAMIC_ALERTS_BY_RESOURCE_ID_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_USER_RESCAN_STATUS_NEWRELIC:
      return {
        ...state,
        error: action.payload,
      }

    case GET_USER_RESCAN_STATUS_NEWRELIC_SUCCESS:
      return {
        ...state,
        new_relic_rescan_status: action.payload.scan_completed,
      }

    case GET_USER_RESCAN_STATUS_NEWRELIC_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    default:
      return state
  }
}

export default NewRelic;